const ClaimSalesConfig = [
  {
    name: "Claim_Sales_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Sales_Person_Mobile_Number",
        label: "Salesperson Mobile Number",
        type: "apiButtonInput",
        masterName: "UserByNumber",
        header: {
          usertype: "sales",
          Licensee: process.env.REACT_APP_ERP_BACKEND_LICENSEE_CODE,
          Company: process.env.REACT_APP_ERP_BACKEND_COMPANY_CODE,
          Branch: process.env.REACT_APP_ERP_BACKEND_BRANCH_CODE,
        },
        max: 10,
        isRequired: true,
        ValidationType: "VALID_STRING",
      },
      {
        id: Math.random() * 10,
        name: "Sales_Person_Name",
        label: "Salesperson Name",
        type: "text",
        min: 2,
        isRequired: true,
        disabled: true,
        ValidationType: "VALID_STRING",
      },
      {
        id: Math.random() * 10,
        name: "Search_Account",
        label: "Search Account",
        type: "apiButtonInput",
        masterName: "SearchAccount",
        header: { usertype: "sales", "X-GraphQL-Server": "secondary" },
        variable: { searchField: "Unique_Id" },
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Account_ID",
        label: "Account",
        type: "text",
        min: 2,
        isRequired: true,
        disabled: true,
        ValidationType: "VALID_STRING",
      },
      {
        id: Math.random() * 10,
        name: "Sales_Bill",
        label: "Sales Bill",
        placeholder: "Purchase Plan",
        masterName: "SalesBillOFAccount",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary", usertype: "sales" },
        },
        type: "InputDropForQuery",
        Reference_field: "Search_Account",
        isRequired: true,
      },
    ],
  },
  {
    name: "Documents",
    label: "Documents",
    fields: [
      {
        id: Math.random() * 10,
        name: "Payment_Image",
        label: "Payment Image",
      },
    ],
  },
];

export { ClaimSalesConfig };
